import type {
  ClarificationOption,
  ProposalActionOption,
  TrainingProposalChange,
} from './message';

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

/** replay / sessionDetail：是 string 就返回（含空串），不 trim */
export const readString = (value: unknown): string | undefined =>
  typeof value === 'string' ? value : undefined;

/** streamReducer：非空 string，不 trim */
export const nonEmptyString = (value: unknown): string | undefined =>
  typeof value === 'string' && value ? value : undefined;

/** proposalAcceptance：trim 后非空 */
export const trimmed = (value: unknown): string | undefined => {
  if (typeof value !== 'string') return undefined;
  const text = value.trim();
  return text || undefined;
};

export const readClarificationOptions = (
  raw: unknown
): ClarificationOption[] => {
  if (!Array.isArray(raw)) return [];
  return raw.flatMap((item) => {
    if (!isRecord(item) || typeof item.label !== 'string' || !item.label) {
      return [];
    }
    const id = typeof item.id === 'string' && item.id ? item.id : item.label;
    return [
      {
        id,
        label: item.label,
        recommended: item.recommended === true,
      },
    ];
  });
};

export const readProposalOptions = (raw: unknown): ProposalActionOption[] => {
  if (!Array.isArray(raw)) return [];
  return raw.flatMap((item) => {
    if (!isRecord(item)) return [];
    const action = readString(item.action) || '';
    const label = readString(item.label) || '';
    const content = readString(item.content)?.trim();
    if (!action || !label) return [];
    return [{ action, label, ...(content ? { content } : {}) }];
  });
};

export const readProposalChanges = (raw: unknown): TrainingProposalChange[] => {
  if (!Array.isArray(raw)) return [];
  return raw.flatMap((item) => {
    if (!isRecord(item)) return [];
    return [
      {
        content_type: readString(item.content_type) || '',
        operation: readString(item.operation) || '',
        target_ref: readString(item.target_ref) || '',
        before: isRecord(item.before) ? item.before : null,
        after: isRecord(item.after) ? item.after : null,
      },
    ];
  });
};

export const formatToolInput = (value: unknown): string | undefined => {
  if (typeof value === 'string' && value) return value;
  if (!isRecord(value)) return undefined;
  if (typeof value.command === 'string' && Object.keys(value).length === 1) {
    return value.command;
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return undefined;
  }
};

export const toolResultStatus = (
  output: string | undefined,
  isError: boolean
): 'done' | 'error' =>
  isError || output?.trimStart().startsWith('Error:') ? 'error' : 'done';

/** 随机串本体。调用方自行决定前缀分隔符（`_` 或 `-`）。 */
export const randomIdSuffix = () => {
  const uuid = globalThis.crypto?.randomUUID();
  return uuid || `${Date.now()}_${Math.random()}`;
};
